export const STUDENT_NOTIFICATION_RECEIVED = 'student-notification-received';

/**
 * @param {{ title?: string, body?: string, notificationId?: string }} detail
 */
export function dispatchStudentNotificationReceived(detail = {}) {
    if (typeof window === 'undefined') {
        return;
    }
    window.dispatchEvent(new CustomEvent(STUDENT_NOTIFICATION_RECEIVED, { detail }));
}
